<template>
    <div class="my-pro">
        <div class="pro-content">
            <div class="pro-group">
                <div v-if="deleteProList.length != 0">
                    <div class="pro-list" v-for="(item, index) in deleteProList" :key="index">
                        <div class="pro-item-head">
                            <img src="../../assets/img/phone-sence.png" alt="">
                            <div class="pro-item-content">
                            <div>{{ item.name }}</div>
                            <div>ID：{{item.id}}</div>
                            </div>
                        </div>
                        <div class="pro-item-btn">
                            <span @click="recoveryItem(item.id)">恢复到项目</span>
                            <span @click="confirm(item.id)">彻底删除</span>
                        </div>
                    </div>
                </div>
                <div v-if="deleteProList.length == 0" style="text-align: center;position:absolute;top:50%;margin-top:-150px;left:50%;margin-left:-90px">
                  <img style="width:180px;" src="../../assets/img/recycle-bin.png" alt="">
                  <div>回收站中暂无数据</div>
                </div>
            </div>
        </div>
        <!-- <router-link target="_blank" rel="opener" to="/Communication" class="dialogBox">
            <a-icon style="z-index:1000;font-size:25px" type="message" />
        </router-link> -->
    </div>
  </template>
  
  <script>
  const columns = [
    {
      title: 'name',
      dataIndex: 'name',
      width: '25%',
      scopedSlots: { customRender: 'name' },
    },
    {
      title: 'age',
      dataIndex: 'age',
      width: '15%',
      scopedSlots: { customRender: 'age' },
    },
    {
      title: 'address',
      dataIndex: 'address',
      width: '40%',
      scopedSlots: { customRender: 'address' },
    },
    {
      title: 'operation',
      dataIndex: 'operation',
      scopedSlots: { customRender: 'operation' },
    },
  ];
  
  const data = [];
  export default {
    name: 'RecycleBin',
    props: {
      msg: String
    },
    data() {
      this.cacheData = data.map(item => ({ ...item }));
      return {
        formLayout: 'horizontal',
        form: this.$form.createForm(this, { name: 'coordinated' }),
        data,
        columns,
        editingKey: '',
        keyword: '',
        proList: [],
        visible: false,
        newName: '',
        projectId: '',
        ifShowRecycle: false,
        deleteProList: [],
      };
    },
    methods: {
        confirm(id) {
            this.$confirm({
            title: '提示',
            content: '确认要删除吗？',
            okText: '确认',
            cancelText: '取消',
            icon: 'warning',
            onOk: ()=> {
                this.deleteProItem(id)
            },
            })
        },
        deleteProItem(id) {
            this.axios.post('/api/project/recycleBin/delete', {
                id: id,
            })
            .then(response=> {
                if(response.data.code == 0){
                this.queryDeleteProList()
                }else{
                this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        queryDeleteProList() {
            this.axios(
            {
                method:'get',
                url:'/api/project/list', 
                params: {
                  keyword: '',
                  status: '',
                  type: '',
                  hasDelete: true
                }
            }
            )
            .then(response=> {
            if(response.data.code == 0){
                this.deleteProList = response.data.data
            }else{
                this.$message.error(response.data.message);
            }
            })
            .catch(error=> {
            console.log(error)
            })
        },
        recoveryItem(id) {
            this.axios.post('/api/project/recycleBin/recovery', {
                id: id,
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.queryDeleteProList()
                    this.$emit('changeAttention', false)
                    this.$emit('changeAttention', true)
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
    },
    mounted: function() {
      this.sessionData('set','currentMenu','MyProject');
      this.queryDeleteProList()
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped  lang="less">
    .my-pro{
      height: 100%;
      // background: #eee;
      padding:24px 0px 24px 24px;
      overflow-y: auto;
      padding-bottom: 50px;
      position: relative;
      .pro-content{
        // width: 1440px;
        margin: 0 auto;
        padding: 0 0px 32px;
        // background: #fff;
        border-radius: 8px;
        .operation-btn-group{
          text-align: center;
          padding: 32px 0;
          .operation-btn-list{
            display: inline-block;
            width: 240px;
            height: 74px;
            line-height: 72px;
            border-radius: 8px;
            border: 1px solid rgba(34, 215, 187, 1);
            background: rgba(34, 215, 187, 0.08);
            cursor: pointer;
            font-size: 16px;
            color: rgba(34, 215, 187, 1);
            i{
              margin-right: 8px;
            }
          }
          .operation-btn-list:nth-child(2){
            margin: 0 24px;
          }
          .operation-btn-list:nth-child(3){
            margin-right: 24px;
          }
        }
        .pro-group{
          .pro-list{
            display: inline-block;
            width: 526px;
            height: 134px;
            box-shadow: rgba(229, 231, 235, 1) solid 1px;
            border: 1px solid rgba(229, 231, 235, 1);
            margin: 0 24px 24px 0;
            border-radius: 8px;
            padding: 24px 20px 0 20px;
            .pro-item-head{
              display: flex;
              img{
                width: 44px;
                margin-right: 12px;
              }
              .pro-item-content{
                flex: 1;
                div:nth-child(1){
                  font-size: 20px;
                  color: rgba(18, 18, 18, 1);
                  font-weight: bold;
                  overflow: hidden;
                  height: 30px;
                }
                div:nth-child(2){
                  font-size: 12px;
                  margin-top: 4px;
                  color: rgba(158, 172, 196, 1);
                }
              }
              i{
                font-size: 16px;
                margin-left: 24px;
                margin-top: 18px;
                cursor: pointer;
              }
              i.active{
                color: rgba(227, 60, 100, 1);
              }
            }
            .pro-item-date{
              text-align: right;
              margin-top: 20px;
              color: rgba(158, 172, 196, 1);
              font-size: 12px;
            }
            .pro-item-btn{
                text-align: right;
              span{
                display: inline-block;
                width: 100px;
                height: 36px;
                border: 1px solid rgba(229, 229, 229, 1);
                font-size: 14px;
                cursor: pointer;
                text-align: center;
                line-height: 36px;
                border-radius: 4px;
              }
              span:nth-child(1){
                margin-right: 11px;
                color: rgba(18, 18, 18, 1);
              }
              span:nth-child(2){
                margin-right: 11px;
                color: rgba(212, 48, 48, 1);
              }
            }
          }
        }
        .card-content{
          display:inline-block;
          width: 348px;
          margin-top:16px;
        }
        .card-distance{
          margin-left:16px
        }
        .delete{
          position: fixed;
          right: 24px;
          bottom: 24px;
          cursor: pointer;
          width: 108px;
          height:40px;
          line-height: 40px;
          background: #fff;
          color: rgba(80, 80, 80, 1);
          font-size: 14px;
          box-shadow: 0px 1px 12px 0px rgba(0, 0, 0, 0.075);
          text-align: center;
        }
        .delete:hover{
          color: #22d7bb;
        }
        .card{
          width: 100%;
          padding: 28px 0px 0px;
          cursor: default;
          height:192px;
          box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.06);
          border: 1px solid #fff;
          // margin-top: 20px;
          // box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.5);
          position: relative;
          background:#fff;
          // i{
          //   color: #1890ff;
          // }
          // i.call-type-in{
          //   color: rgba(255, 196, 66, 1);
          // }
          .new-card{
            display: inline-block;
            width: 25px;
            height: 25px;
            color: rgba(34, 215, 187, 1);
            font-size: 18px;
            // font-weight: 600;
            border-radius: 8px;
            text-align: center;
            line-height: 25px;
            // background: #13C2C2;
          }
          .new-card-text{
            font-size: 16px;
            // font-weight: bold;
            margin-left: 5px;
          }
          .card-time{
            text-align: right;
            margin: 11px 0;
            font-size: 12px;
          }
          .design-state{
            margin-top: 21px;
            font-size: 12px;
            // span:nth-child(1){
            //   margin-right: 100px;
            //   font-size: 14px;
            //   color: rgba(34, 215, 187, 1);
            // }
            color: rgba(204, 204, 204, 1);
          }
          .card-list{
            position: absolute;
            bottom: 20px;
            right: -40px;
            z-index: 100;
            width: 100px;
            height: 208px;
            color: rgba(80, 80, 80, 1);
            background-color: rgba(255, 255, 255, 1);
            font-size: 14px;
            line-height: 41px;
            box-shadow: 0px 9px 9px 0px rgba(0, 0, 0, 0.2);
            text-align: center;
            // display: none;
            li{
              cursor: pointer;
              span{
                margin-left: 8px;
              }
            }
            li:hover{
              background: #eee;
            }
          }
        }
        .card:hover{
          border: 1px dotted rgba(34, 215, 187, 1);
        }
        .add-card{
          text-align: center;
          font-size: 18px;
          padding-top:65px;
          color: rgba(34, 215, 187, 1);
          // line-height: 135px;
        }
        .three-point{
          font-size: 20px;
          font-weight: 300;
          transform: rotate(90deg);
          -ms-transform: rotate(90deg); /* IE 9 */
          -moz-transform: rotate(90deg); /* Firefox */
          -webkit-transform: rotate(90deg); /* Safari and Chrome */
          -o-transform: rotate(90deg); /* Opera */
        }
        .card-title span:nth-child(1){
          display: inline-block;
          // width: 100%;
          font-size: 16px;
          border: 1px solid #fff;
          color: rgba(80, 80, 80, 1);
        }
      }
    }
    .card-tag{
      font-size: 12px;
      margin-top: 10px;
      span{
        float: left;
        font-size: 14px;
        color: rgba(153, 153, 153, 1);
      }
      span:nth-child(even){
        // margin-right: 24px;
        border-radius: 4px;
        min-width: 20px;
        display: inline-block;
        text-align: center;
        height: 22px;
        line-height: 22px;
      }
      span.call-type-in{
        // color: rgba(255, 196, 66, 1);
      }
      span:nth-child(odd){
        margin-right: 1px;
      }
    }
    .path-num:hover{
      text-decoration: underline;
    }
  </style>
  